import { Api } from 'utils';

class ChatService {

    static admin = {
        get: async (params?: any) => Api.createResponse('app/chat',params),
        create: async (params?: any) => Api.createResponse('app/chat/create',params),
        send: async (params?: any) => Api.createResponse('app/chat/send',params),
        view: async (params?: any) => Api.createResponse('app/chat/view',params),
        viewed: async (params?: any) => Api.createResponse('app/chat/viewed',params)
    }

}

export default ChatService;